import React from 'react';
import { motion } from 'framer-motion';
import { Features } from '../components/Features';
export function FeaturesPage() {
  return <div className="bg-sovereign-navy min-h-screen text-white" data-id="element-187">
      <div className="pt-32 pb-12" data-id="element-188">
        <div className="container mx-auto px-6 max-w-7xl text-center" data-id="element-189">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-serif mb-6" data-id="element-190">
            Capabilities
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-300 font-light max-w-2xl mx-auto" data-id="element-191">
            Every feature is designed with a singular purpose: to make
            compliance effortless and invisible.
          </motion.p>
        </div>
      </div>

      <Features data-id="element-192" />

      <section className="py-24 container mx-auto px-6 max-w-7xl border-t border-white/5" data-id="element-193">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-194">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-195">
            <h2 className="text-3xl font-serif text-white mb-6" data-id="element-196">
              Technical Precision
            </h2>
            <p className="text-gray-400 leading-relaxed font-light mb-6" data-id="element-197">
              Our integration sits directly within your WooCommerce
              infrastructure, communicating securely with KRA servers via
              encrypted channels. We handle the complexity of tax types, HS
              codes, and invoice serialization so you never have to.
            </p>
            <ul className="space-y-4 text-gray-400 font-light" data-id="element-198">
              <li className="flex items-center gap-3" data-id="element-199">
                <span className="w-1.5 h-1.5 bg-sovereign-gold rounded-full" data-id="element-200" />
                Automatic HS Code Mapping
              </li>
              <li className="flex items-center gap-3" data-id="element-201">
                <span className="w-1.5 h-1.5 bg-sovereign-gold rounded-full" data-id="element-202" />
                Offline Queue Management
              </li>
              <li className="flex items-center gap-3" data-id="element-203">
                <span className="w-1.5 h-1.5 bg-sovereign-gold rounded-full" data-id="element-204" />
                Multi-currency Support
              </li>
            </ul>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-sovereign-navy-light p-8 border border-sovereign-gold/20 shadow-lg aspect-video flex items-center justify-center" data-id="element-205">
            <div className="text-center" data-id="element-206">
              <div className="text-sovereign-gold text-sm uppercase tracking-widest mb-2" data-id="element-207">
                System Status
              </div>
              <div className="text-white text-2xl font-serif" data-id="element-208">Operational</div>
              <div className="mt-4 flex gap-2 justify-center" data-id="element-209">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-210" />
                <span className="text-xs text-gray-400" data-id="element-211">Live Sync Active</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}